import { API, authClient } from "../index";
import { safeGet } from "../../utils/safeGet";

// Get tiped by id
export const getTipedById = (id) => {
  return authClient().get(`${API}/tiped/${id}`);
};
export const getTipedByEmail = (email) => {
  return authClient().post(`${API}/tiped/email`, email);
};

export const getTipedByQrId = (id) => {
  return safeGet(`${API}/tiped/qr/${id}`);
};

export const getTipeds = () => {
  return authClient().get(`${API}/tiped`);
};

// Create tiped
export const postTiped = async (tiped) => {
  return authClient().post(`${API}/tiped`, tiped);
};

// Update tiped
export const updateTiped = async (id, tiped) => {
  return authClient().put(`${API}/tiped/${id}`, tiped);
};

export const deleteTiped = async (id, tiped) => {
  return authClient().delete(`${API}/tiped/${id}`, tiped);
};

// Get tipeds by businessId (ruta pública, no requiere autenticación)
export const getTipedsByBusinessId = (businessId) => {
  return safeGet(`${API}/tiped/business/${businessId}`);
};
